import { ReactNode } from 'react'

type Props = {
    condition: boolean | null | undefined
    children: ReactNode
    fallback?: ReactNode
}

export const Show = ({ children, fallback, condition }: Props) => <>{condition ? children : fallback}</>
